export const BroadcastMessageType = {
  CLOSE_OTHER_TABS: 'CLOSE_OTHER_TABS',
  CLOSE_ALL_TABS: 'CLOSE_ALL_TABS',
  TOKEN_REFRESHED: 'TOKEN_REFRESHED',
  USER_ACTIVITY: 'USER_ACTIVITY',
  EXPIRATION_ALERT_SHOWN: 'EXPIRATION_ALERT_SHOWN',
  EXPIRATION_ALERT_HIDDEN: 'EXPIRATION_ALERT_HIDDEN',
  CHANNEL: 'global66-session',
} as const;

export type BroadcastMessageType = typeof BroadcastMessageType[keyof typeof BroadcastMessageType];
